import {
  FIELDS_CONFIG,
  MAX_CONDITIONS_PER_FIELD,
} from '../../constants/eligibilityEngine';

export const ACTION_ON_FAIL_LABELS = {
  DENY: 'On Fail: Deny',
  PENDING: 'On Fail: Move to Pending',
};

export const getActionOnFailLabel = key => {
  if (!key) return 'On Fail: Unknown';
  const upper = key.toUpperCase();
  return ACTION_ON_FAIL_LABELS[upper] || `On Fail: ${key}`;
};

export const IF_NULL_OPTIONS = [
  {
    key: 'IGNORE',
    text: 'If Null Ignore the Rule',
    value: 'IGNORE',
    'data-testid': 'if-null-option-IGNORE',
  },
  {
    key: 'DENY',
    text: 'If Null Deny',
    value: 'DENY',
    'data-testid': 'if-null-option-DENY',
  },
];

export const COMPARISON_OPTIONS = [
  { key: 'gte', text: 'Greater Or Equal', value: 'gte' },
  { key: 'gt', text: 'Greater Than', value: 'gt' },
  { key: 'lte', text: 'Less Or Equal', value: 'lte' },
  { key: 'lt', text: 'Less Than', value: 'lt' },
  { key: 'eq', text: 'Equal', value: 'eq' },
];

export const INCLUDE_EXCLUDE_OPTIONS = [
  { key: 'include', text: 'Include', value: 'include' },
  { key: 'exclude', text: 'exclude', value: 'exclude' },
];

export const TIME_CONDITION_OPTIONS = [
  { key: 'after', text: 'After', value: 'after' },
  { key: 'before', text: 'Before', value: 'before' },
];

export const TIME_PERIOD_OPTIONS = [
  { key: 'am', text: 'AM', value: 'AM' },
  { key: 'pm', text: 'PM', value: 'PM' },
];

export const TIMEZONE_OPTIONS = [
  { key: 'est', text: 'EST', value: 'EST' },
  { key: 'cst', text: 'CST', value: 'CST' },
  { key: 'mst', text: 'MST', value: 'MST' },
  { key: 'pst', text: 'PST', value: 'PST' },
];

export { FIELDS_CONFIG, MAX_CONDITIONS_PER_FIELD };

// Lookup map keyed by field config id for fast access
export const FIELDS_CONFIG_MAP = Object.fromEntries(
  FIELDS_CONFIG.map(f => [f.id, f])
);
